import { render, staticRenderFns } from "./AssessmentsDelete.vue?vue&type=template&id=95596d4e"
import script from "./AssessmentsDelete.vue?vue&type=script&lang=js"
export * from "./AssessmentsDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports